import { GetEcshopTradesHistoryApi } from "@/features/accounts/ecshop/services/get-trades-history-api";
import { GetEcshopTradesHistoryRequestModel } from "@/features/accounts/ecshop/services/get-trades-history-model";

/// EC取込履歴取得処理
export class GetEcshopTradesHistoryService {
  private getEcshopTradesHistoryApi = new GetEcshopTradesHistoryApi();

  /**
   * EC取込履歴取得API実行
   */
  public async getEcshopTradesHistory(param: GetEcshopTradesHistoryRequestModel) {
    return await this.getEcshopTradesHistoryApi.getEcshopTradesHistory(param);
  }
}
